import React ,{useState,useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import logo from '../assets/Strong-IT-Logo.png'
import '../css/index.css'
const Header = () => {
 
  


  // below is our code 

  const [isFr,setIsFr]=useState(false);

  const [opt,setOpt]=useState("en");
  const { t } = useTranslation(["home"]);

  
  const handleClick = (e) => {

    i18n.changeLanguage(e.target.value);
    setOpt(e.target.value)
  }
  
 
 

  const mhandleClick = (lang, e) => {
    i18n.changeLanguage(lang);
    let elm = e.target.parentElement.childNodes;
    elm.forEach(element => {
      element.classList.remove("active")
    });
    e.target.classList.toggle("active");
  }


  const showMenu = (e) => {
    e.target.parentElement.childNodes[1].classList.toggle("show")
  }

  // change lang based on location 

  let xhttp = new XMLHttpRequest();
  xhttp.onload = function() {
    if (this.readyState === 4 && this.status === 200) {
      let country_code = this.responseText.replace(/(\r\n|\n|\r)/gm,"").split('loc=');
      country_code = country_code[1].split('tls=');
      country_code = country_code[0];
      if (country_code==="CA") {
        setIsFr(true);
      }
    }
  }
  xhttp.abort();
  
  xhttp.open("GET", "https://www.cloudflare.com/cdn-cgi/trace", true);
  xhttp.send();

  

  useEffect(() => {
    setOpt(localStorage.getItem("i18nextLng"))
   }, [opt])
  useEffect(() => {
    if (isFr===true) {
      i18n.changeLanguage("fr");
      setOpt(localStorage.getItem("i18nextLng"))
    }
  }, [isFr])
  

  return (
    <>
      <nav className='mp'>
        <div className="logo">
        <a href="/"><img src={logo} alt="logo" /></a> 
        </div>
        <div className="navbar">
          <div className="links">
            <NavLink to="/" >{t("nav.Home")}</NavLink>
            <NavLink to="/about">{t("nav.About")}</NavLink>
            <NavLink to="/services">{t("nav.Services")}</NavLink>
          </div>
          <div className="contactBtn">
            <NavLink to="/contact">
              <button>{t("nav.Contact")}</button>
            </NavLink>
          </div>
          <div className="languageControl">
            {opt==="en" ?
              <select value="en" className="custom-select" style={{ width: "100px" }} onChange={handleClick} name="langControl" id="langControl">
              <option  value="en">English</option>
              <option value="fr">Français</option>
              </select>
             :
             <select value="fr" className="custom-select" style={{ width: "100px" }} onChange={handleClick} name="langControl" id="langControl">
              <option value="en">English</option>
              <option  value="fr">Français</option>
            </select>
             }
            
          </div>
        </div>
        <div onClick={(e) => showMenu(e)} className="menu">
          <img src={require("../assets/Menu.png")} alt="" />
        </div>
      </nav>
      <hr className='line' />
      <div className="langCtrl">
        <p className='active' onClick={(e) => mhandleClick("en", e)}>English</p>
        <p onClick={(e) => mhandleClick("fr", e)}>Français</p>
      </div>
      <hr className='line' />
    </>
  )
}

export default Header;


// let xhttp = new XMLHttpRequest();
//   xhttp.onreadystatechange = function() {
//     if (this.readyState === 4 && this.status === 200) {
//       let country_code = this.responseText.replace(/(\r\n|\n|\r)/gm,"").split('loc=');
//       country_code = country_code[1].split('tls=');
//       country_code = country_code[0];
//       console.log(country_code)
//       if (country_code === "US") {
//           console.log("Your country is usa");
//           i18n.changeLanguage("fr");
//       }
//     }
//   };
//   //OPEN HTTP Request
//   xhttp.open("GET", "https://www.cloudflare.com/cdn-cgi/trace", true);
//   xhttp.send();